import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import classes from "./RedirectPage.module.css";
import Cookies from "js-cookie";
import { AiOutlineCheckCircle, AiOutlineCloseCircle, AiOutlineLoading3Quarters } from 'react-icons/ai';
import { loginApi, printLogsApi } from '../http/http';

const RedirectPage = () => {

    const [searchParams, setSearchParams] = useSearchParams();
    const [msisdn, setMsisdn] = useState(null);
    const [message, setMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (searchParams.get("msisdn")) {
            setMsisdn(searchParams.get("msisdn"));
        }
        if (searchParams.get("message")) {
            setMessage(searchParams.get("message"));
        }
    }, [searchParams]);

    const saveLogs = async () => {
        try {
            const response2 = await axios.post(printLogsApi, {
                url: window.location.href,
            });
            console.log(response2, 'response2...');
        } catch (error) {
            console.log(error, 'error---');
        }
    }
    useEffect(() => {
        saveLogs();
    }, []);

    console.log(message, 'message');

    // useEffect(() => {
    //     if (!msisdn) {
    //         return;
    //     }
    //     if (message == "Success" || message == `"Success"`) {
    //         Cookies.set('msisdn', msisdn, { expires: 1 });
    //         setTimeout(() => navigate('/home'), 2000);
    //     }
    // }, [message, msisdn]);

    const handleFormSubmission = async () => {
        try {
            setLoading(true);
            const response = await axios.post(loginApi, {
                msisdn: msisdn
            });
            setLoading(false);
            Cookies.set('msisdn', msisdn, { expires: 1 });
            navigate('/home');
        }
        catch (error) {
            setLoading(false);
            console.log("logging failure callback delay issue!");
        }
    }

    useEffect(() => {
        let apiInterval = null;

        if (!loading && msisdn) {
            if (message == "Success" || message == `"Success"`) {
                apiInterval = setInterval(() => {
                    handleFormSubmission();
                }, 2000);
            }
        }

        return () => {
            if (apiInterval) {
                clearInterval(apiInterval);
            }
        };
    }, [msisdn, message, loading]);

    if (!msisdn) {
        return (
            <div className={classes.wrapper}>

                <div className={classes.statusContainer}>
                    <AiOutlineCloseCircle className={classes.iconFailure} />
                    <h2>Subscription Failed</h2>
                    <p>We were unable to complete your subscription. Please try again.</p>
                </div>
            </div>

        )
    }

    if (message == "Success" || message == `"Success"`) {
        return (
            <div className={classes.wrapper}>

                <div className={classes.statusContainer}>
                    <AiOutlineCheckCircle className={classes.iconSuccess} />
                    <h2>Subscription Successful</h2>
                    <p>You will be redirected shortly to Kids Fusion...</p>
                </div>
            </div>

        )
    }
    else if (message == "Failure" || message == `"Failure"`) {
        return (
            <div className={classes.wrapper}>

                <div className={classes.statusContainer}>
                    <AiOutlineCloseCircle className={classes.iconFailure} />
                    <h2>Subscription Failed</h2>
                    <p>We were unable to complete your subscription. Please try again.</p>
                </div>
            </div>

        )
    }
    else {
        return (
            <div className={classes.wrapper}>

                <div className={classes.statusContainer}>
                    <AiOutlineLoading3Quarters className={classes.iconLoading} />
                    <h2>Processing...</h2>
                    <p>Please wait while we verify your subscription.</p>
                </div>
            </div>

        )
    }
}

export default RedirectPage


// 0|rashiGames_callback  | {"url":"https://ke.rashigames.com/redirect?requestid=6b7ec233-662a-4ecd-90a4-a3f9c6ec3765&mfilter_id=1751365255430wpjmb&msisdn=0724480213&message=Failure&error=invalid_traffic"} Front end logs----------->